import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { type GetExchangesReq, getExchanges } from './mapper';

export const refundQueryKey = createQueryKeys('refund', {
  exchanges: (params: GetExchangesReq) => ({
    queryFn: async () => {
      const data = await getExchanges(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
});

export type RefundQueryKey = inferQueryKeys<typeof refundQueryKey>;
